module.exports = __webpack_public_path__ + "static/media/temperature.044f71bb.png";